import React, {type PropsWithChildren} from 'react';

import {Button, Icon} from '@albert-io/atomic';

interface Props {
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
  /** Forwarded to the underlying `Button`, for callers that need to measure or anchor to it. */
  ref?: React.Ref<HTMLElement>;
}

export default function Grade({
  children,
  className,
  disabled = false,
  label = 'Grade',
  onClick,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <Button
      className={className}
      color='primary'
      disabled={disabled}
      onClick={onClick}
      roundness='pill'
      type='button'
      variant='text'
      {...rest}
    >
      <Icon icon='file-pen' iconStyle='regular' className='mr-x1' />
      {children ?? label}
    </Button>
  );
}
